interface DataLayerEvent {
  event: string;
  [eventData: string]: any;
}

/**
 * This is a helper function to record events and associated data for
 * Adobe AEM Analytics.
 *
 * @param eventName Name of the event to record
 * @param data Uniquely keyed data for the event being recorded
 *
 * @example
 * trackEvent({
 *  event: "GetOfferList",
 *  offers: [{
 *    id: "OFFERID_1",
 *    displayid: "DISPLAY_ID_1",
 *    title: "OFFER_TITLE_1",
 *    description: "OFFER_DESC_1",
 *    start: "MM/DD/YYYY",
 *    end: "MM/DD/YYYY",
 *    source: "OFFER_SOURCE_1",
 *    status: "OFFER_STATUS_1",
 *    pref: "OFFER_PREF_1",
 *    ruleId: "OFFER_RULE_ID_1",
 *    propertyList: ["PROPERTY1","PROPERTY2","PROPERTY3"],
 *    type: "OFFER_TYPE_1"}
 * ])
 *
 * @example
 * trackEvent({
 *  event: "UpdateOfferFilters",
 *  offerFilters: {
 *    type: "destination",
 *    value: ["ARIZONA","CALIFORNIA"]
 *  }
 * })
 */
export const trackEvent = (event: DataLayerEvent) => {
  /**
   * Default the window dataLayer object to an empty array if it is not defined.
   */
  if (window.dataLayer === undefined) {
    window.dataLayer = [];
  }

  if (event) {
    window.dataLayer.push(event);
  }
};
